/* @ngInject */

export default ($rootScope, dateTimeService) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function OtherMortgage(
    idSecurity,
    idLiability,
    lender,
    lenderOtherName,
    bsb,
    accountNumber,
    interestRate,
    mortgageType,
    limit,
    balance,
    repayment,
    repaymentType,
    ownership,
    exitCosts,
    priority,
    interestOnlyExpiryDate,
    fixedExpiryDate,
    endDate,
    isRefinanced,
    isLoanIncreased,
    isTaxDeducted
  ) {
    this.idSecurity = idSecurity;
    this.idLiability = idLiability;
    this.lender = lender;
    this.lenderOtherName = lenderOtherName;
    this.bsb = bsb;
    this.accountNumber = accountNumber;
    this.interestRate = interestRate;
    this.mortgageType = mortgageType;
    this.limit = limit;
    this.balance = balance;
    this.repayment = repayment;
    this.repaymentType = repaymentType;
    this.ownership = ownership;
    this.exitCosts = exitCosts;
    this.priority = priority;
    this.interestOnlyExpiryDate = interestOnlyExpiryDate;
    this.fixedExpiryDate = fixedExpiryDate;
    this.endDate = endDate;
    this.isRefinanced = isRefinanced;
    this.isLoanIncreased = isLoanIncreased;
    this.isTaxDeducted = isTaxDeducted;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  OtherMortgage.Blank = function () {
    return OtherMortgage.Build({
      idSecurity: '',
      idLiability: '',
      lender: '',
      lenderOtherName: '',
      bsb: '',
      accountNumber: '',
      interestRate: 0,
      mortgageType: false,
      limit: 0,
      balance: 0,
      repayment: 0,
      repaymentType: false,
      ownership: '',
      exitCosts: 0,
      priority: '',
      interestOnlyExpiryDate: 0,
      fixedExpiryDate: 0,
      endDate: 0,
      isRefinanced: false,
      isLoanIncreased: false,
      isTaxDeducted: false
    });
  };
  OtherMortgage.Build = function (data) {
    return new OtherMortgage(
      data.idSecurity ? data.idSecurity : '',
      data.idLiability ? data.idLiability : '',
      data.lender ? data.lender : '',
      data.lenderOtherName ? data.lenderOtherName : '',
      data.bsb ? data.bsb : '',
      data.accountNumber ? data.accountNumber : '',
      data.interestRate ? data.interestRate : 0,
      data.mortgageType ? data.mortgageType : false,
      data.limit ? data.limit : 0,
      data.balance ? data.balance : 0,
      data.repayment ? data.repayment : 0,
      data.repaymentType ? data.repaymentType : false,
      data.ownership ? data.ownership : '',
      data.exitCosts ? data.exitCosts : 0,
      data.priority ? data.priority : '',
      data.interestOnlyExpiryDate ? data.interestOnlyExpiryDate : 0,
      data.fixedExpiryDate ? data.fixedExpiryDate : 0,
      data.endDate ? data.endDate : 0,
      data.isRefinanced ? data.isRefinanced : false,
      data.isLoanIncreased ? data.isLoanIncreased : false,
      data.isTaxDeducted ? data.isTaxDeducted : false
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  OtherMortgage.prototype.getSetInterestOnlyExpiryDate = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.interestOnlyExpiryDate) {
          this.interestOnlyExpiryDateObject = '';
        }
        const interestOnlyExpiryDateObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.interestOnlyExpiryDateObject = date;
        this.interestOnlyExpiryDate = moment
          .utc(interestOnlyExpiryDateObject)
          .startOf('day')
          .format('X');
      } else {
        this.interestOnlyExpiryDateObject = date;
        this.interestOnlyExpiryDate = 0;
      }
    }
    if (!this.interestOnlyExpiryDateObject) {
      if (this.interestOnlyExpiryDate) {
        const interestOnlyExpiryDateObject = dateTimeService.setDate(
          this.interestOnlyExpiryDate,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.interestOnlyExpiryDateObject = interestOnlyExpiryDateObject;
      } else {
        this.interestOnlyExpiryDateObject = '';
      }
    }
    return this.interestOnlyExpiryDateObject;
  };
  OtherMortgage.prototype.getSetFixedExpiryDate = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.fixedExpiryDate) {
          this.fixedExpiryDateObject = '';
        }
        const fixedExpiryDateObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.fixedExpiryDateObject = date;
        this.fixedExpiryDate = moment.utc(fixedExpiryDateObject).startOf('day').format('X');
      } else {
        this.fixedExpiryDateObject = date;
        this.fixedExpiryDate = 0;
      }
    }
    if (!this.fixedExpiryDateObject) {
      if (this.fixedExpiryDate) {
        const fixedExpiryDateObject = dateTimeService.setDate(
          this.fixedExpiryDate,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.fixedExpiryDateObject = fixedExpiryDateObject;
      } else {
        this.fixedExpiryDateObject = '';
      }
    }
    return this.fixedExpiryDateObject;
  };
  OtherMortgage.prototype.getSetEndDate = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.endDate) {
          this.endDateObject = '';
        }
        const endDateObject = dateTimeService.setDate(date, $rootScope.CurrentTimeZone(), true);
        this.endDateObject = date;
        this.endDate = moment.utc(endDateObject).startOf('day').format('X');
      } else {
        this.endDateObject = date;
        this.endDate = 0;
      }
    }
    if (!this.endDateObject) {
      if (this.endDate) {
        const endDateObject = dateTimeService.setDate(
          this.endDate,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.endDateObject = endDateObject;
      } else {
        this.endDateObject = '';
      }
    }
    return this.endDateObject;
  };
  OtherMortgage.prototype.deleteDateObject = function () {
    delete this.interestOnlyExpiryDateObject;
    delete this.fixedExpiryDateObject;
    if (this.endDate) {
      delete this.endDateObject;
    }
  };

  return OtherMortgage;
};
